import { WCL_URL } from "config";

const addWCLScriptToPage = () => {
    const script = document.createElement('script');
    script.src = `${WCL_URL}/ax-wcl.esm.js`;
    script.type = 'module';
    document.head.appendChild(script);
}

const addWCLStylesToPage = () => {
    const style = document.createElement('link');
    style.href = `${WCL_URL}/ax-wcl.css`;
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.media = 'all';
    document.head.appendChild(style);
}

const initWCL = () => {
    addWCLScriptToPage();
    addWCLStylesToPage();
}

export {initWCL};
